<div class="flex min-w-0 gap-1.5">
  <input
    type="number"
    min="0"
    step="any"
    class="form-input min-w-12 flex-1 rounded-xs px-2.5 py-1.5 font-mono text-[12.5px] leading-5"
    [value]="amountText()"
    [attr.aria-label]="ariaLabel()"
    (change)="onAmount($any($event.target))" />
  <span class="sr-only" [id]="unitLabelId">{{ unitLabel() }}</span>
  <div class="w-28 shrink-0">
    <app-select
      [id]="unitSelectId"
      [labelledBy]="unitLabelId + ' ' + unitSelectId"
      [items]="unitItems()"
      [value]="unit()"
      (valueChange)="onUnit($event)" />
  </div>
</div>
